export default __webpack_public_path__ + "static/media/bonus_logo.1d423675.jpg";